import { getUserback } from '@userback/widget';
import { useRouterState } from '@tanstack/react-router';
import { useEffect } from 'react';
import { feedbackConfig, loadFeedbackWidget } from '../../lib/feedback.ts';
import { useSession } from '../../lib/session.tsx';

/**
 * The Feature Request / Bug Report button (TS-1755): Userback, the widget Leve uses, reporting to
 * the CRM's own Userback project (chosen by the page's domain). Userback draws its own launcher
 * (bottom right) and records screenshots, screen recordings and attachments itself; this only
 * loads it once (`lib/feedback.ts`) and says who is reporting, from which app, release and page.
 */
export function FeedbackWidget() {
  const { me } = useSession();
  const page = useRouterState({ select: (s) => s.location.pathname });
  const { id, name, email } = me.user;
  const organisationId = me.organisation.id;

  useEffect(() => {
    const config = feedbackConfig();
    if (!config) return;
    let cancelled = false;
    const apply = () => {
      const userback = getUserback();
      if (cancelled || !userback) return;
      userback.identify(id, { name, email });
      // Userback records the page URL itself; these say which app and build it came from.
      userback.setData({ app: 'crm', release: config.release, page, organisationId });
    };
    if (getUserback()) apply();
    else void loadFeedbackWidget(config.token, { id, name, email }).then(apply);
    return () => {
      cancelled = true;
    };
  }, [id, name, email, organisationId, page]);

  return null;
}
